import {
    MESSAGE_CHANGED,
} from '../actions/types';

const INITIAL_STATE = {
    
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/textReducer.js